const ModalService = {
    about: about,
    share: share,
};

function about() {
    Yodel.about({
        title: 'About BURN.link',
        qa: [
            {
                question: 'What is this?',
                answer: 'BURN.link allows you to send secure, encrypted messages that self-destruct once viewed.'
            },
            {
                question: 'Is this safe to use?',
                answer: 'Yes. We encrypt the message in your browser and give you a link containing the decryption key.\n ' +
                    'The message can be decrypted only by someone with that link, and once decrypted, it is permanently destroyed.\n ' +
                    'Importantly, we never see the link with the decryption key and are not able to view your secrets.\n ' +
                    'It is known only to you and the person you send the link to.\n ' +
                    '<br><br>In addition, you can enable two-factor verification, which would require the recipient to not only have the link,\n ' +
                    'but to also enter a verification code sent to their phone number. For this you must provide the recipient\'s mobile phone number.\n'
            },
            {
                question: 'What happens to my message after it is "burned"?',
                answer: 'Your message (and the recipient\'s phone number, if provided) are permanently wiped from our server as soon as the message is viewed.'
            },
            {
                question: 'Do you share the phone numbers with anyone?',
                answer: 'Absolutely not. We store your phone number only until the message has been viewed. ' +
                    'We don\'t share this information with anyone, ever.'
            },
            {
                question: 'Who made this?',
                answer: 'This utility is brought to you by <a href="http://codymikol.com/" target="_blank">Cody Mikol</a>,\n ' +
                    '<a href="https://github.com/Neuman968" target="_blank">John Flynn</a>,\n ' +
                    '<a href="http://kostasnasis.com/" target="_blank">Kostas Nasis</a>,\n ' +
                    'and <a href="http://yingyingzhang.com/" target="_blank">YingYing Zhang</a>.</p>'
            },
            {
                question: 'Questions? Suggestions?',
                answer: 'Email us at <a href="mailto:burnlink@justshipped.io">burnlink@justshipped.io</a>. We\'d love to hear from you.'
            }
        ],
        project: 'BURN.link'
    })
}

function share() {
    Yodel.share({
        title: 'Tell a Friend',
        body: `
            Find this site useful? We’d really appreciate if you helped us spread the word.
            Have feedback, questions, suggestions? We’d love to hear from you! Tweet us <a>@justshipped</a> or email us at <a href="mailto:burnlink@justshipped.io">burnlink@justshipped.io</a>.
            <div style="
                display:flex;
                flex-direction: column;
                justify-content:center;
                align-items: center;
                margin: 8px;">
                <button
                style="
                    cursor: pointer;
                    background: #43A1EC;
                    color:white;
                    border: none;
                    text-align: left;
                    width:230px;
                    height:42px;
                    margin: 6px;
                    border-radius: 4px;
                    display:flex;
                    align-items: center"
                onclick="window.open('https://twitter.com/intent/tweet?url=https%3a%2f%2fburn.link%2f&amp;text=BURN.link+lets+you+send+secure,+self-destructing+messages', '_blank')"
                target="_blank"
                >
                <img src="/images/icon-twitter.svg" style="height: 18px; margin: 0 6px">
                <span>Share on Twitter<span>
                </button>

                <button
                style="
                    cursor: pointer;
                    background: #4669AD;
                    color:white;
                    border: none;
                    text-align: left;
                    width:230px;
                    height:42px;
                    margin: 6px;
                    border-radius: 4px;
                    display:flex;
                    align-items: center"
                onclick="window.open('https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent(window.location.href),'facebook-share-dialog','width=626,height=436')"
                target="_blank"
                >
                <img src="/images/icon-fb.svg" style="height: 20px; margin: 0 6px">
                <span>Share on Facebook</span>
                </button>
            </div>`,
        project: 'BURN.link'
    })
}

export default ModalService;